import React, { Component, PropTypes } from 'react';
import {
  doAddFavorite,
  doDeleteFavorite,
  openLoginFormRequest
} from '../actions';
import isLoggedIn, { objectToFormData } from '../utils/index';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';

class OrganizationFavBtn extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    favoriteAction: 'add',
    showHelpText: false
  };

  handleAddFavorite = e => {
    e.preventDefault();
    if (!isLoggedIn(this.props.auth.user)) {
      return this.props.openLoginFormRequest()
    }
    this.props.doAddFavorite(objectToFormData({organization: this.props.db_id}));
    this.setState({ favoriteAction: 'delete' });
  };

  handleDeleteFavorite = e => {
    e.preventDefault();
    if (!isLoggedIn(this.props.auth.user)) {
      return this.props.openLoginFormRequest()
    }
    this.props.doDeleteFavorite({
      id: this.props.db_id
    });

    this.setState({ favoriteAction: 'add' });
  };

  handleMouseOver = (e) => {
    this.setState({showHelpText: true})
  }

  handleMouseOut = (e) => {
    this.setState({showHelpText: false})
  }

  render() {
    const { user } = this.props.auth;
    let favButton = '';
    let favoriteHelpText = '';

    favButton = <div className="favButton favButtonOff" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} onClick={this.handleAddFavorite}><i className="fa fa-heart-o" aria-hidden="true"></i></div>;

    favoriteHelpText = <div className="organizationDetail-addMyList-tooltip addTooltip">
      Add to My Favorites
    </div>

    if (this.state.favoriteAction == 'delete') {

      favButton = <div className="favButton favButtonOn" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} onClick={this.handleDeleteFavorite}><i className="fa fa-heart" aria-hidden="true"></i></div>

      favoriteHelpText = <div className="organizationDetail-addMyList-tooltip removeTooltip">
        Remove from My Favorites
      </div>
    }


    if (user) {
      let favOrgs = [];
      favOrgs = user.favorites.map(fav => {
        return fav.organization;
      });

      let db_id = '';

      db_id = Number(this.props.db_id);

      if(favOrgs.indexOf(db_id) !== -1) {

        favButton = <div className="favButton favButtonOn" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} onClick={this.handleDeleteFavorite}><i className="fa fa-heart" aria-hidden="true"></i></div>;

        favoriteHelpText = <div className="organizationDetail-addMyList-tooltip removeTooltip">
          Remove from My Favorites
        </div>
      }
    }

    if (!this.state.showHelpText) {
      favoriteHelpText = '';
    }

    return(
      <div className="organization-favButtonWrapper">
        {favButton}
        {favoriteHelpText}
      </div>
    )
  }
};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doDeleteFavorite,
    doAddFavorite,
    openLoginFormRequest
  }
)(OrganizationFavBtn);



// WEBPACK FOOTER //
// ./src/components/OrganizationFavBtn.jsx